<template>
  <v-overlay
    v-if="show"
    :value="true"
    class="auth-loading-overlay"
    persistent
  >
    <div class="loading-content">
      <img
        src="@/assets/img/eKitabu-bug.png"
        alt="eKitabu"
        class="logo"
      >
      <div class="shop-text mt-4">
        {{ $t('common.shopName') }}
      </div>
      <v-progress-circular
        color="primary"
        indeterminate
        size="48"
        class="mt-6"
      />
    </div>
  </v-overlay>
</template>

<script>
export default {
  name: 'AuthLoadingOverlay',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
.auth-loading-overlay {
  z-index: $z-top;
  background-color: var(--v-background-base);
}

.auth-loading-overlay :deep(.v-overlay__scrim) {
  background-color: var(--v-background-base) !important;
  opacity: 1 !important;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.logo {
  max-width: 200px;
  height: auto;
}

.shop-text {
  font-size: 48px;
  font-weight: 500;
  color: var(--v-black-base);
  text-align: center;
}
</style>
